import axios from "axios"; 

const DesignationBasedService = {
  // Fetch all purchase orders
  async getAll(date) {
    try {
      const response = await axios.get(`/DesignationBasedCount/GetDesignationAttendance?p_date=${date}`, {
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching locations:", error);
      throw error;
    }
  },
}

export default DesignationBasedService;
